export const focus = (ref, focusOptions = {}) =>
  ref.current && ref.current.focus && ref.current.focus(focusOptions);
